import { AppNS } from 'app';
import { compact } from 'lodash-es';

export const can = (
  user: AppNS.User | undefined,
  action: AppNS.Permission,
  companyId?: string
): boolean => {
  if (!user) {
    return false;
  }

  if (user.employments.length === 0) {
    return true;
  }

  let employment: AppNS.Employment | undefined = user.employments[0];

  if (companyId && user.employments.length > 1) {
    employment = user.employments.find(
      (item: AppNS.Employment) => item.companyId === companyId
    );
    return (employment && employment.permissions.includes(action)) || false;
  }

  return user.employments.some((item: AppNS.Employment) =>
    item.permissions.includes(action)
  );
};

export const companiesWithPermission = (
  user: AppNS.User | undefined,
  action: AppNS.Permission
): AppNS.Company[] => {
  if (!user) {
    return [];
  }

  return compact(
    user.employments.map((item: AppNS.Employment) =>
      item.permissions.includes(action) || action === 'any'
        ? item.company
        : null
    )
  );
};
